import api from '../axios/axiosConfig';
import type { AuthContextType } from '../context/AuthContext';

export interface GoogleUser {
  email: string;
  name: string;
  picture: string;
  sub: string; // Google ID
}

export const authenticateWithGoogle = async (
  accessToken: string,
  auth: AuthContextType
) => {
  try {
    const response = await api.post('/authGoogle', {
      access_token: accessToken,
    });

    console.log('response.data', response.data);

    if (response.data.token) {
      const token = response.data.token;
      auth.setToken(token, `token-${window.location.pathname.split('/')[1]}`);
    }

    return true;
  } catch (error: any) {
    console.log('Erro na autenticação Google:', error);
    console.error('Erro na autenticação Google:', error);
    console.error('Detalhes do erro:', {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    return false;
  }
};
